


















































import Vue from 'vue'
import _ from 'lodash'
import QcqViewGrid from '@/components/QcqViewGrid.vue'
import { LevelOfEducation } from '@/model/qcq/LevelOfEducation'
import { Jobs } from '@/model/qcq/Jobs'
import { Specialization } from '@/model/qcq/Specialization'
import { Detail } from '@/model/qcq/Detail'
import { LOAD_DETAIL, LOAD_EDUCATION, LOAD_JOBS, LOAD_SPECIALIZATION } from '@/store/action-types'
import { EmployeeQcqQualification } from '@/model/employee/EmployeeQcqQualification'
import { EmployeeQcqQualificationPayload } from '@/types/payload'

interface ComponentData {
  levelOfEducationData: Array<LevelOfEducation>
  jobsData: Array<Jobs>
  specializationsData: Array<Specialization>
  detailData: Array<Detail>
  formData: EmployeeQcqQualification | undefined
  educationId: number | null
  jobId: number | null
  specializationId: number | null
  detailsId: number | null
  educationValidationRules: Array<Function>
}

export default Vue.extend({
  name: 'QcqQualificationDialog',

  components: {
    QcqViewGrid
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    employeeId: Number,
    loading: Boolean,
    dialogData: {
      type: Object as () => EmployeeQcqQualification
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      levelOfEducationData: [],
      jobsData: [],
      specializationsData: [],
      detailData: [],
      formData: undefined,
      educationId: null,
      jobId: null,
      specializationId: null,
      detailsId: null,
      educationValidationRules: [
        required
      ],
    }
  },

  watch: {
    show (newVal: boolean): void {
      if (newVal) {
        const form: any = this.$refs['form']
        if(form) {
          form.resetValidation()
        }
        this.educationId = null
        this.jobsData = []
        this.specializationsData = []
        this.detailData = []
        this.formData = _.cloneDeep(this.dialogData)
        if (this.formData && this.formData.educationId) {
          this.educationId = this.formData.educationId
          this.$store.dispatch(LOAD_JOBS, this.formData.educationId)
            .then((data: Array<Jobs>) => {
              this.jobsData = data
              this.specializationsData = []
              this.detailData = []
            })
        }
      }
    }
  },

  methods: {
    levelOfEducationChange (): void {
      this.jobId = null
      this.specializationId = null
      this.detailsId = null

      this.$store.dispatch(LOAD_JOBS, this.educationId)
        .then((data: Array<Jobs>) => {
          this.jobsData = data
          this.specializationsData = []
          this.detailData = []
        })
    },

    onJobsClicked (row: any): void {
      this.jobId = row.id

      this.$store.dispatch(LOAD_SPECIALIZATION, row.id)
        .then((data: Array<Specialization>) => {
          this.specializationsData = data
          this.detailData = []
        })
    },

    onSpecializationClicked (row: any): void {
      this.specializationId = row.id

      this.$store.dispatch(LOAD_DETAIL, row.id)
        .then((data: Array<Detail>) => {
          this.detailData = data
        })
    },

    onDetailClicked (row: any): void {
      this.detailsId = row.id
    },

    onSaveButtonClick (): void {
      if (this.formData) {
        const payload: EmployeeQcqQualificationPayload = {
          educationId: this.educationId,
          jobId: this.jobId,
          specializationId: this.specializationId,
          detailsId: this.detailsId,
          action: '',
          id: this.formData.id,
          employeeId: this.employeeId
        }
        this.$emit('save', payload)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },
  },

  async mounted (): Promise<void> {
    this.$store.dispatch(LOAD_EDUCATION)
      .then((data: Array<LevelOfEducation>) => {
        const gridData = data.map((item: LevelOfEducation) => {
          return item.commonGridData as any
        })
        this.levelOfEducationData = gridData
      })
  }
})
